import { SORT_ORDER } from '@/constants'
import apiClient from '@/lib/apiClient'
import type { SortingState } from '@tanstack/react-table'
import { endpoints } from './endPoint'

export type CreateCategoryPayload = {
  id?: string
  name: string
  description?: string
  status: 'active' | 'inactive'
}

export const fetchCategory = async (params: {
  limit?: number
  page?: number
  search?: string
  sort?: SortingState
}) => {
  try {
    const queryParams = new URLSearchParams()
    if (params.limit) queryParams.append('limit', params?.limit?.toString())
    if (params.page) queryParams.append('page', params?.page?.toString())
    if (params.search) queryParams.append('search', params?.search)
    if (params?.sort && params?.sort?.length > 0) {
      queryParams.append(
        'order',
        params?.sort?.[0].desc ? SORT_ORDER.DESC : SORT_ORDER.ASC
      )
    }
    if (params?.sort && params?.sort?.length > 0) {
      queryParams.append('orderOn', params?.sort?.[0].id || 'createdAt')
    }

    const response = await apiClient.get(
      `${endpoints.category.getCategory}?${queryParams.toString()}`
    )
    return response.data
  } catch (error) {
    console.error('Error fetching events:', error)
    throw error
  }
}

export const createCategory = async (payload: CreateCategoryPayload) => {
  try {
    const response = await apiClient.post(
      endpoints.category.createCategory,
      payload
    )
    return response.data
  } catch (error) {
    console.error('Error while creating category:', error)
    throw error
  }
}

export const updateCategory = async ({
  id,
  payload,
}: {
  id: string
  payload: CreateCategoryPayload
}) => {
  try {
    const response = await apiClient.put(
      endpoints.category.updateCategory(id),
      payload
    )
    return response.data
  } catch (error) {
    console.error('Error while creating category:', error)
    throw error
  }
}

export const deleteCategory = async (id: string) => {
  try {
    const response = await apiClient.delete(
      endpoints.category.deleteCategory(id)
    )
    return response.data
  } catch (error) {
    console.error('Error white deleting category')
    throw error
  }
}
